import { AccountData } from "./accountData.model";

import { Commissions } from "./commissions.model";

import { Customer } from "./customer.model";
import { PersonalData } from "./personalData.model";
import { NewData } from "./newData.model";

export class NewPostusers{
    constructor(
        public accountData : AccountData = new AccountData(),
        public personalData : PersonalData = new PersonalData(),
        public commissions : Commissions = new Commissions(),
        public customer : Customer = new Customer(),
        public data: NewData = new NewData()
    ){}
}